import { useMutation } from '@apollo/client'
import { addStudentEnrollmentMutation } from '../../../appsync/graphql/student'
import {
  clearStudentBfsDataIfNoBfsEnrollments,
  updateStudentEnrollments,
} from '../../../appsync/actions/student'
import {
  updateHasEligibleBfsEnrollments,
  updateStudentHasEnrollments,
} from '../../../appsync/actions/settings'
import { formatAppsyncErrors } from '../../../appsync/utils'
import useUserSettingsQuery from '../../../hooks/useUserSettingsQuery'

const useStudentAddEnrollmentMutation = ({
  educationPeriod,
  input,
  bfsEnrollment,
  isTransfer,
  onError,
}) => {
  const { refetch: refetchUserSettings } = useUserSettingsQuery()
  const [mutate, { data: rawData = {}, called, loading, error: rawError = null, client }] =
    useMutation(addStudentEnrollmentMutation, {
      variables: { code: educationPeriod, input },
      onCompleted: async () => {
        updateStudentHasEnrollments(client)
        updateHasEligibleBfsEnrollments(client, bfsEnrollment)
        if (isTransfer) {
          await refetchUserSettings()
          clearStudentBfsDataIfNoBfsEnrollments({ cache: client.cache, educationPeriod })
        }
      },
      onError,
      update(cache, { data }) {
        // updateStudentEnrollments expects data to be a property in the object
        updateStudentEnrollments({
          cache,
          response: { data },
          key: 'addStudentEnrollment',
          educationPeriod,
        })
      },
    })

  const data = rawData?.addStudentEnrollment ?? {}
  const error = rawError ? formatAppsyncErrors(rawError) : null

  return {
    mutate,
    data,
    called,
    loading,
    error,
  }
}

export default useStudentAddEnrollmentMutation
